/**
 * Composable for fetching available payment methods from the CMS.
 *
 * @returns {Promise<Ref<PaymentMethodsData>>} A promise resolving to the payment methods data.
 * @description Retrieves payment methods based on the current locale, VSE, and content ID.
 * @example
 * // Fetch available payment methods
 * const paymentMethods = await usePaymentMethods()
 */
export const usePaymentMethods = async () => {
  const localePath = useLocalePath()

  /**
   * Query parameters for fetching payment methods.
   *
   * @type {Object}
   * @property {string} locale - The current localized path.
   * @property {string} [vse] - Optional VSE query parameter.
   * @property {string} [contentId] - Optional content ID query parameter.
   */
  const query = {
    locale: localePath(''),
    vse: useRoute().query.vse,
    contentId: useRoute().query.contentId,
  }

  const { data } = await useFetch('/api/cms/getPaymentMethods', {
    query,
    getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key],
    dedupe: 'defer',
  })

  return data
}
